<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div class="text-center">
        <h2 class="title text-center"><span>Self Service</span></h2>
        <h3 class="title text-center mt-1 mb-0"><span>PAY BILL</span></h3>
        <div class="card shadow mb-3">
          <img class="img-logo mx-auto" :src='"../assets/images/fmce-logo.png"' alt="">
          <h3 class="text-center mb-0">Welcome {{ currentPatient.full_name }}</h3>
          <p class="text-center">Please enter a valid bill number to pay bill</p>
          <form class="theme-form" @submit.prevent="submit" novalidate="novalidate" autocomplete="false">
            <div class="form-group">
              <input type="text" class="form-control text-uppercase text-center" placeholder="Enter Bill Number Here" v-model.trim="$v.billNo.$model">
              <template v-if="$v.billNo.$error">
                <span
                  class="form-text text-danger text-center"
                  v-if="!$v.billNo.required"
                >
                  Please enter a valid bill number to get started.
                </span>
              </template>
            </div>
            <div class="form-button text-center">
              <button type="submit" class="btn btn-custom btn-lg btn-block theme-color">CONTINUE</button>
            </div>
            <div class="form-button text-center mt-2">
              <button @click="cancel()" type="button" class="btn btn-custom btn-lg btn-block btn-danger">CANCEL</button>
            </div>
          </form>
        </div>
        <small><b>Nuclear Associates &amp; Consulting Services</b><br>No. 3, Alhaja Kofoworola Crescent off Obafemi Awolowo Way, Ikeja-Lagos</small><br>
        <img class="img-payments mt-3" :src='"../assets/images/payments/globalpay.gif"' alt="">
        <img class="img-payments" :src='"../assets/images/payments/isw.png"' alt="">
        <img class="img-payments" :src='"../assets/images/payments/etranzact.jpg"' alt=""><br>
        <img class="img-payments" :src='"../assets/images/payments/visa.gif"' alt="">
        <img class="img-payments" :src='"../assets/images/payments/verve.png"' alt="">
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { POST_BILL } from '@/store/bill.module'
import { PURGE_PATIENT } from '@/store/welcome.module'

export default {
  name: 'Bill',
  data () {
    return {
      billNo: '',
      loading: false
    }
  },
  validations: {
    billNo: { required }
  },
  computed: {
    ...mapState({
      errors: (state) => state.bill.errors
    }),
    ...mapGetters(['currentPatient'])
  },
  mounted () {},
  methods: {
    async submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true

        this.$store.dispatch(POST_BILL, this.billNo)
          .then(response => {
            this.billNo = ''
            this.loading = false

            this.$nextTick(() => {
              this.$v.$reset()
            })

            this.$router.push({ name: 'Payment' })
          })
          .catch(error => {
            this.loading = false
            this.$swal({
              title: 'Warning',
              text: error.message,
              icon: 'warning',
              heightAuto: false
            })
          })
      }
    },

    cancel () {
      this.loading = true
      this.$store.dispatch(PURGE_PATIENT)
        .then(response => {
          this.loading = false
          this.$router.push({ name: 'Welcome' })
        })
        .catch(error => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/bill.vue